import React, {useState} from 'react';
import {Form, Input, Select, Switch, Button, Card, Row, Col, Typography, Modal, message, Space, Checkbox} from 'antd';
import {UserOutlined, PhoneOutlined, LockOutlined} from '@ant-design/icons';
import './Common.module.css';
import styles from './Common.module.css';
import {addUserRequest} from "../api";
import AliyunVodUploader from "./AliyunVodUploader";

const {Title} = Typography;
const {Option} = Select;

const { TextArea } = Input;
const AddAccountForm = (props) => {
    const [form] = Form.useForm();
    const [accountStatus, setAccountStatus] = useState(true);
    const [billingRulesType, setBillingRulesType] = useState(0);

    const onFinish = (values) => {
        console.log('提交的表单数据:', values);
        // 这里可以添加API调用或其他提交逻辑
    };


    const closeCommon = () => {
        props.closeCommonModal()
    };

    function addUser() {

        form.validateFields()
            .then(values => {
                console.log('表单数据:', values);


                var user_type = '1';
                var name = values.name;
                var phone = values.phone;
                var pwd = values.pwd;
                var status = accountStatus === true ? '1' : '3';

                var beizhu = values.beizhu === undefined ? '' : values.beizhu;

                // 调用 API
                addUserRequest(user_type, name, phone, pwd, status, beizhu, (data) => {
                    console.log(data);
                    if (data.ret === '1') {
                        message.success("添加成功", 1);
                        props.updateData();
                        props.closeCommonModal()
                    } else {
                        message.error(data.msg, 1);
                    }
                });
            })
    }

    const handleUploadSuccess = (uploadInfo, fileInfo) => {
        console.log('视频上传成功:', uploadInfo, fileInfo);
        // 处理上传成功后的逻辑
        // 例如保存VideoId到数据库
    };

    const handleUploadError = (code, message, fileInfo) => {
        console.error('视频上传失败:', code, message, fileInfo);
    };
    return (
        <Modal
            maskClosable={false}
            // visible={true}
            open={props.openStatus}
            onCancel={closeCommon}
            footer={null} // 设置 footer 为 null 移除默认按钮
            width={800}
            // className="add-account-container"
        >
            <Card className={styles["form-card"]} span={20}>
                <div className={styles["form-title"]}>添加应用信息</div>
                <Form
                    form={form}
                    layout="horizontal"
                    onFinish={onFinish}
                    className="account-form"
                >
                    <Form.Item
                        label="应用名称"
                        name="appName"
                        rules={[{required: true, message: '请输入应用名称'}]}
                        labelAlign="right"
                        labelCol={{span: 5}}
                    >
                        <Input
                            placeholder="请输入应用名称"
                            size="large"
                        />
                    </Form.Item>

                    <Form.Item
                        label="文字介绍"
                        name="appDes"
                        rules={[{required: true, message: '请输入文字介绍'}]}
                        labelAlign="right"
                        labelCol={{span: 5}}
                    >
                        <Input
                            placeholder="请输入文字介绍"
                            size="large"
                        />
                    </Form.Item>

                    <Form.Item
                        label="教学视频"
                        name="teachingVideo"
                        rules={[{required: true, message: '请选择教学视频'}]}
                        labelAlign="right"
                        labelCol={{span: 5}}
                    >
                        <AliyunVodUploader
                            onUploadSuccess={handleUploadSuccess}
                            onUploadError={handleUploadError}
                        />
                    </Form.Item>


                    <Form.Item
                        label="跳转链接"
                        name="login"
                        rules={[{required: true, message: '请输入跳转链接'}]}
                        labelAlign="right"
                        labelCol={{span: 5}}
                    >
                        <Input
                            placeholder="请输入跳转链接"
                            size="large"
                        />
                    </Form.Item>
                    <Form.Item
                        label="计费规则"
                        name="pwd"
                        rules={[{required: true, message: '请输入登录密码'}]}
                        labelAlign="right"
                        labelCol={{span: 5}}
                    >
                        <Checkbox
                            checked={billingRulesType === 1}
                            onChange={(e)=>{
                                console.log(e)
                                setBillingRulesType(e.target.checked?1:0);
                            }}
                        >
                            按次消耗计费
                        </Checkbox>
                        <Checkbox
                        checked={billingRulesType === 2}
                        onChange={(e)=>{
                            console.log(e)
                            setBillingRulesType(e.target.checked?2:0);
                        }}
                        >
                            资源消耗计费
                        </Checkbox>
                        <Checkbox
                        checked={billingRulesType === 3}
                        onChange={(e)=>{
                            console.log(e)
                            setBillingRulesType(e.target.checked?3:0);
                        }}
                        >
                            免费
                        </Checkbox>
                    </Form.Item>
                    {/*<Form.Item*/}
                    {/*    label="应用自定义计费设置"*/}
                    {/*    name="jifeishezhi"*/}
                    {/*    // rules={[{required: true, message: '请输入登录密码'}]}*/}
                    {/*    labelAlign="right"*/}
                    {/*    labelCol={{span: 5}}*/}
                    {/*>*/}
                    {/*    <Switch*/}
                    {/*        checked={props.checkedStatus}*/}
                    {/*        onChange={(checked) => {*/}
                    {/*        }}*/}
                    {/*        // checkedChildren="开"*/}
                    {/*        // unCheckedChildren="关"*/}
                    {/*        // style={{ backgroundColor: user.status=='1' ? '#52c41a' : '#bfbfbf' }}*/}
                    {/*        style={{marginLeft: 10, marginRight: 10}}*/}
                    {/*    />*/}
                    {/*    <Button*/}
                    {/*        type="primary"*/}
                    {/*        >*/}
                    {/*        去设置*/}
                    {/*    </Button>*/}
                    {/*</Form.Item>*/}
                    <Form.Item
                        label="调用应用消耗积分"
                        name="chushijifen"
                        rules={[{required: true, message: '请输入调用应用消耗积分'}]}
                        labelAlign="right"
                        labelCol={{span: 5}}
                    >
                        <Input
                            placeholder="请输入调用应用消耗积分"
                            size="large"
                        />
                    </Form.Item>
                    <Form.Item
                        label="使用应用消耗计费"
                        name="schoolAccountNumber"
                        rules={[{required: true, message: '请输入使用应用消耗计费'}]}
                        labelAlign="right"
                        labelCol={{span: 5}}
                    >
                        <Input
                            placeholder="请输入使用应用消耗计费"
                            size="large"
                        />
                    </Form.Item>
                    <Form.Item
                        label="学校账号状态"
                        name="accountStatus"
                        labelAlign="right"
                        labelCol={{span: 5}}
                    >
                        <Switch
                            checked={props.checkedStatus}
                            onChange={(checked) => {
                            }}
                            // checkedChildren="开"
                            // unCheckedChildren="关"
                            // style={{ backgroundColor: user.status=='1' ? '#52c41a' : '#bfbfbf' }}
                            style={{marginLeft: 10, marginRight: 10}}
                        />
                    </Form.Item>
                    <Form.Item
                        label="备注"
                        name="beizhu"
                        labelAlign="right"
                        labelCol={{span: 5}}
                    >
                        <TextArea
                            placeholder='输入备注信息'

                            // value={tishiValue}
                            // onChange={changeTishiFn}
                            // readOnly={disableCreate}
                        />
                    </Form.Item>
                    <Form.Item className={styles["form-actions"]}>

                        <Button

                            size="large"
                            // onClick={() => form.resetFields()}
                            onClick={(e)=>{
                                // props.cancel()
                                closeCommon()
                            }}
                        >
                            取消
                        </Button>

                        <Button
                            type="primary"
                            htmlType="submit"
                            size="large"
                            style={{marginLeft: 16}}
                        >
                            确认
                        </Button>

                    </Form.Item>
                </Form>
            </Card>
        </Modal>
    );
};

export default AddAccountForm;

